import { render, staticRenderFns } from "./PalletPatternDetails.vue?vue&type=template&id=251b10bc&scoped=true&"
import script from "./PalletPatternDetails.vue?vue&type=script&lang=ts&"
export * from "./PalletPatternDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PalletPatternDetails.vue?vue&type=style&index=0&id=251b10bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251b10bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/3ce44491/1/fsi-lab/soft/app/robot-config/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VAlert,VAvatar,VBtn,VCard,VCardText,VContainer,VFlex,VImg,VLayout,VSpacer})
